import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Card, Slider } from 'antd';

import { loyaltyTextColor } from './textLevelColorHelper';
import { MEMBERSHIP_LEVEL_DATA } from '../../constants/levels';

import './style.css';


const LevelUpgradePath = ({ toLevel, upgradePath }) => {
  const nextLoyaltyColor = loyaltyTextColor(toLevel.toLowerCase());
  return (
    <div className="level-upgrade-path mt-4">
      <div className="flex justify-between">
        <small className="text-gray-link p-0 m-0">{upgradePath.msg}</small>
        <span className={`${nextLoyaltyColor} uppercase pl-3`}>{toLevel}</span>
      </div>
      <Slider className="slider-level" disabled tooltipVisible={false}
              min={0} max={upgradePath.maxValue} value={upgradePath.value}
      />
    </div>
  );
};

const LevelBoxComponent = ({ loy3MembershipInfo, currentLevel }, context) => {
  const loyaltyColor = loyaltyTextColor(currentLevel.toLowerCase());
  const nextLevel = loy3MembershipInfo.membershipInfo.memberShipName || null;

  const brandConstants = useSelector(state => state.global.brandConstants);
  const upgradePathFn = MEMBERSHIP_LEVEL_DATA[currentLevel]?.upgradePath || null;
  const upgradePath = upgradePathFn ? upgradePathFn(loy3MembershipInfo.membershipInfo, context) : null;

  return (
    <Card className="card-level-box w-full">
      <small className="text-gray-link font-semibold uppercase">{context.t('Your Level')}</small>
      <h3>{brandConstants.loyaltyName}
        <span className={`font-semibold uppercase ${loyaltyColor}`}>
          {currentLevel}
        </span>
      </h3>
      {upgradePath && <LevelUpgradePath upgradePath={upgradePath} toLevel={nextLevel} />}
    </Card>
  )
};

LevelBoxComponent.propTypes = {
  level: PropTypes.object,
};

LevelBoxComponent.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default LevelBoxComponent;
